import { Tooltip, Typography } from '@mui/material';
import { formatDateLitteral } from 'helpers/format';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const DeliverableDateCell = React.memo((row: OrderWorkunit) => {
  const [t] = useTranslation();

  return (
    <Tooltip
      title={
        <>
          {row?.delivery_date && formatDateLitteral(row?.delivery_date)}
          {!row?.delivery_date && row?.forecast_date && formatDateLitteral(row?.forecast_date)}
          {!row?.delivery_date && !row?.forecast_date && t('N/A')}
        </>
      }
    >
      <Typography variant="body2" noWrap>
        {row?.delivery_date && formatDateLitteral(row?.delivery_date)}
        {!row?.delivery_date && row?.forecast_date && formatDateLitteral(row?.forecast_date)}
        {!row?.delivery_date && !row?.forecast_date && t('N/A')}
      </Typography>
    </Tooltip>
  );
});

export default DeliverableDateCell;
